import React, { Component } from 'react';
import { ProgressBar } from 'react-bootstrap';

class ProgressBarComponent extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showLabel: this.props.showLabel
        };
        this.handlePageClick = this.handlePageClick.bind(this);
        this.handlePageLimitChange = this.handlePageLimitChange.bind(this);
    }

    componentDidMount() {}

    handlePageClick(data) {
        const { onPageChanged = (f) => f } = this.props;
        onPageChanged(data);
    }
    handlePageLimitChange(event) {
        const { onPageLimitChange = (f) => f } = this.props;
        onPageLimitChange(event);
    }
    render() {
        const progressNow = this.props.progressNow || 0;
        return (
            <>
                <ProgressBar
                    className={this.props.className}
                    animated={progressNow < 100}
                    striped={progressNow < 100}
                    now={progressNow}
                    label={this.state.showLabel ? `${progressNow}%` : ''}
                />
            </>
        );
    }
}

function mapStateToProps(state) {
    return {};
}

export { ProgressBarComponent };
